import { combineReducers } from "redux-immutable";

export default combineReducers({
  register: require("./register").default,
});
